import { DEDUCTIBLES_MAP } from 'components/landing/constants';

export default function getDeductibles (culture = 'es-ar') {
    return DEDUCTIBLES_MAP[culture] || DEDUCTIBLES_MAP['es-ar'];
}
